import { render, staticRenderFns } from "./ApiInfo.vue?vue&type=template&id=bd0dc8b6&scoped=true&"
import script from "./ApiInfo.vue?vue&type=script&lang=js&"
export * from "./ApiInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0dc8b6",
  null
  
)

export default component.exports